import { render, staticRenderFns } from "./GrowingBranches.vue?vue&type=template&id=4b7f3d69&scoped=true&"
import script from "./GrowingBranches.vue?vue&type=script&lang=ts&"
export * from "./GrowingBranches.vue?vue&type=script&lang=ts&"
import style0 from "./GrowingBranches.vue?vue&type=style&index=0&id=4b7f3d69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f3d69",
  null
  
)

export default component.exports